var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoadControl(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 445.04 403.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M342.81,384.71a83.11,83.11,0,1,1,83.11-83.1,83.21,83.21,0,0,1-83.11,83.1m-125.65-103h25.3a101.5,101.5,0,0,0,17.11,79.14H217.16Zm-99.62.36h79.14v78.78H117.54Zm-98.34,0H98.34v78.78H19.2Zm0-262.9H394.64V66.59H19.2Zm0,164.93H98.34v78.41H19.2Zm79.14-19.57H19.2V85.79H98.34Zm198,0H217.16V85.79H296.3ZM117.54,184.14h79.14v78.41H117.54Zm277.1-19.57H315.5V85.79h79.14Zm-198,0H117.53V85.79h79.14Zm51.6,98H217.16v-78.4H296.3v26.44a102.92,102.92,0,0,0-48,52m94.54-63.25a102.16,102.16,0,0,0-27.31,3.81v-19h79.14v29.4a101.47,101.47,0,0,0-51.83-14.25m71,28.84V9.6a9.6,9.6,0,0,0-9.6-9.6H9.6A9.6,9.6,0,0,0,0,9.6V370.49a9.6,9.6,0,0,0,9.6,9.6H206.28c.22,0,.42-.11.64-.13s.42.13.64.13h68.26a9.8,9.8,0,0,0,1.2-.24A102.21,102.21,0,0,0,413.84,228.13"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M396,292H352.41V241.34a9.61,9.61,0,1,0-19.21,0V301.6a9.6,9.6,0,0,0,9.6,9.6H396a9.6,9.6,0,0,0,0-19.2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadControl);
export default __webpack_public_path__ + "static/media/load-control.f2034ca8bdf83f75a6768f39ea95e2c3.svg";
export { ForwardRef as ReactComponent };